import { render, staticRenderFns } from "./SaveHistoryGaauButton.vue?vue&type=template&id=c018040c&"
import script from "./SaveHistoryGaauButton.vue?vue&type=script&lang=js&"
export * from "./SaveHistoryGaauButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports